import * as React from "react";
import PageHeading from "../../components/PageHeading";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { LinearProgress } from "@material-ui/core";
import GameAdminTicketIdField from "./GameAdminTicketIdField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useSnackbar } from "notistack";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

function GameAdminSmartCheckInFormSearch({
  ticketReservations,
  game,
  setStep,
  setTicketReservation,
}) {
  const { enqueueSnackbar } = useSnackbar();
  return (
    <>
      <PageHeading mt={2}>Ticket-Nummer eingeben</PageHeading>
      <Formik
        initialValues={{
          ticketId: "",
        }}
        validationSchema={Yup.object().shape({
          ticketId: Yup.string()
            .length(4)
            .required("Gib nur die Ziffern 3-6 ein"),
        })}
        onSubmit={async (values, { resetForm }) => {
          const ticketId = `${game.id.substring(0, 2)}${values.ticketId}`;
          const reservation = ticketReservations.find(
            (res) => res.id === ticketId
          );
          if (reservation == null) {
            enqueueSnackbar("Ticket nicht gefunden", {
              variant: "error",
              autoHideDuration: 2000,
              anchorOrigin: { vertical: "top", horizontal: "center" },
            });
            resetForm();
            return;
          }
          await setTicketReservation(reservation);
          await setStep(2);
        }}
      >
        {({ submitForm, isSubmitting }) => (
          <Form>
            {isSubmitting ? (
              <LinearProgress mb={1} />
            ) : (
              <Field
                component={GameAdminTicketIdField}
                name="ticketId"
                variant="outlined"
                type="number"
                label="Ticket Nummer"
                autoFocus
                autoComplete="off"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {game.id.substring(0, 2).toUpperCase()}
                    </InputAdornment>
                  ),
                }}
                helperText="Gib die Ziffern 3-6 der Ticket-ID ein, die Suche startet dann automatisch."
                inputProps={{
                  autoComplete: "off",
                  maxLength: 4,
                  pattern: "[0-9]*",
                }}
                customSubmitFn={submitForm}
              />
            )}
          </Form>
        )}
      </Formik>
      <Box mt={3} style={{ textAlign: "center" }}>
        <Button variant="text" onClick={() => setStep(3)}>
          Liste aller Tickets
        </Button>
      </Box>
    </>
  );
}

export default GameAdminSmartCheckInFormSearch;
